export const formatOptions = (values) => values.map((value) => ({
  value,
  label: `${value} %`,
}))

const formatDate = (isoDateString) => {
  if (!isoDateString) return ''

  try {
    const date = new Date(isoDateString)

    if (Number.isNaN(date.getTime())) {
      return isoDateString
    }

    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')

    return `${year}-${month}-${day}`
  } catch (error) {
    return isoDateString
  }
}

const renderDate = (isoDateString) => {
  return formatDate(isoDateString)
}

const formatMoneyValue = (value) => {
  const numValue = value !== null && value !== undefined ? Number(value) : 0
  return numValue.toFixed(2)
}

const renderMoneyValue = (value) => `$${formatMoneyValue(value)}`

const renderPercentage = (value) => `${value}%`

export { renderDate, formatMoneyValue, renderMoneyValue, renderPercentage }
